__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "learning-platform";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@nw/auth-sdk", "1.1.0", function() { return __webpack_require__.e(7992).then(function() { return function() { return __webpack_require__(797992); }; }); });
			register("hoist-non-react-statics", "3.3.1", function() { return function() { return __webpack_require__(447814); }; }, 1);
			register("hoist-non-react-statics", "3.3.2", function() { return function() { return __webpack_require__(999300); }; }, 1);
			register("hoist-non-react-statics", "3.3.2", function() { return function() { return __webpack_require__(212511); }; }, 1);
			register("hoist-non-react-statics", "3.3.2", function() { return function() { return __webpack_require__(890705); }; }, 1);
			register("hoist-non-react-statics", "3.3.2", function() { return function() { return __webpack_require__(849536); }; }, 1);
			register("hoist-non-react-statics", "3.3.2", function() { return function() { return __webpack_require__(329787); }; }, 1);
			register("hoist-non-react-statics", "3.3.2", function() { return function() { return __webpack_require__(865852); }; }, 1);
			register("react-dom", "17.0.2", function() { return function() { return __webpack_require__(515749); }; }, 1);
			register("react-router-dom", "5.1.2", function() { return function() { return __webpack_require__(874618); }; }, 1);
			register("react", "17.0.2", function() { return function() { return __webpack_require__(330969); }; }, 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};